import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../../config";

const apiUrl = config.apiUrl;

const CreateCta = ({ onWebinarCtaCreated }) => {
  const [formData, setFormData] = useState({
    slug: "",
    title: "",
    description: "",
    button_text: "",
    button_link: ""
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);

    try {
      const response = await axios.post(`${apiUrl}/ctas`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (onWebinarCtaCreated) {
        onWebinarCtaCreated();
      }
      
      // Reset form after successful submission
      setFormData({
        slug: "",
        title: "",
        description: "",
        button_text: "",
        button_link: ""
      });
      
      alert("CTA created successfully!");
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "An error occurred while creating the CTA.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Call To Action</h2>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1">Slug (URL identifier):</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., home-page-cta"
          />
        </div>

        <div>
          <label className="block mb-1">Title:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., Ready to get started?"
          />
        </div>

        <div>
          <label className="block mb-1">Description:</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            rows="3"
            required
            placeholder="Enter a compelling description..."
          ></textarea>
        </div>

        <div>
          <label className="block mb-1">Button Text:</label>
          <input
            type="text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., Get Started Now"
          />
        </div>

        <div>
          <label className="block mb-1">Button Link:</label>
          <input
            type="url"
            name="button_link"
            value={formData.button_link}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            required
            placeholder="e.g., https://example.com/signup"
          />
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full py-2 px-4 bg-green-500 text-white rounded hover:bg-green-600 disabled:bg-gray-400"
        >
          {isSubmitting ? "Creating..." : "Create CTA"}
        </button>
      </form>
    </div>
  );
};

export default CreateCta;